package one.healthium.onboarding.domain.configs

import kotlinx.serialization.Contextual
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import one.healthium.domain.common.Color
import one.healthium.domain.common.PlatformValueSerializer

@Serializable
@SerialName("welcome")
data class WelcomeScreenConfig(
    @SerialName("title") val title: String? = null,
    @SerialName("subtitle") val subtitle: String? = null,
    @SerialName("background_color_gradient") val backgroundGradient: List<@Contextual Color>? = null,
    @SerialName("app_icon") @Serializable(with = PlatformValueSerializer::class) val appIcon: String? = null,
) : ScreenConfig
